import {
  ABILITY_STATUS,
  ACCESS_TYPE,
  APPLICATION_STATUS,
  CERTIFICATION_RESULT,
  SEX,
  UNIT_STATUS,
  STATISTICS_STATUS,
  TAX_DECLARATION_STATUS,
  NOTE_TYPE,
  COLLECTION_STATUS,
  NORMAL_STATUS,
  CHECK_STATUS,
  INTO_ACCOUNT_STATUS,
  CLJG,
  GXCLJG,
  GXLXDM,
  GXZT,
  INVOICE_TYPE,
  SQRZLX,
  CHYYDM,
  HZQRXXZTDM,
  LRFSF,
  QRJKP,
  SZ,
  BDKLX,
  FPLX,
  FPLZZT,
  FPZT,
  YCPZZT,
  YTZT,
  QDDRZT,
  CEZSLXDM,
  CKYWSYZCDM,
  FPHXZ,
  YHZCBS,
  GMFZRRBZ,
  JSFS,
  SCZT,
  SCZT2,
  SGFPLXDM,
  TDYS,
  ZZSJZJTDM,
  LZFPPZDM,
  SFZZFPBZ,
  YKJJZFPBZ,
  YXBZ,
  FPZL,
  SJLX,
  NSRLX,
  FXNSRLX,
  NSRYJJB,
  FXNSRBZ,
  GZKQZT,
  GZPZLX,
  GZYWZT,
  GJJG,
  GJLX,
  SFHS,
  XFS_YT,
  FPYT,
  HBCFBZ,
  SFSB,
  HZQRZT,
  EDCZRL,
  EDBGJG,
  ZZSSBZT,
  KJZT,
  FPLY,
  JSFSDM,
  PTGXZT,
  PTRZZT,
  XML,
  XFSYTBQ,
  ZZSYTBQ,
  RZZT,
  YXQYZT,
  XZYJFW,
  XZYJLX,
  FJSJLX,
  XZZT,
  FPPZ,
  TJFS,
  CHECK_TYPE,
  TJQR_FPLX,
  JFJL,
  TJFX_TJLX,
  DDKJZT,
  SFSX,
  CYJG,
  ZJLX,
  JTGJLX,
  TSFW,
  YLJGLXDM,
  YBLXDM,
  TSGXZT,
  ZNGXFS,
  CLZT,
  CZZT,
  ZZSSBJXDKHZ,
  RCPJJKCGXTJJG,
  ZFQD,
  MTZL
} from '@/enum/enum'

interface ValToLab {
  [key: number | string]: string
}
// 准入类型
export const accessType: ValToLab = {
  [ACCESS_TYPE.jrdw]: '直连单位',
  [ACCESS_TYPE.sydw]: '使用单位'
}
// 乐企单位状态
export const unitStatus: ValToLab = {
  [UNIT_STATUS.yc]: '异常',
  [UNIT_STATUS.wtb]: '未同步',
  [UNIT_STATUS.zc]: '正常',
  [UNIT_STATUS.tbz]: '同步中'
}
// 能力状态
export const abilityStatus: ValToLab = {
  [ABILITY_STATUS.ykt]: '已开通',
  [ABILITY_STATUS.dcs]: '待测试',
  [ABILITY_STATUS.shz]: '审核中',
  [ABILITY_STATUS.wkt]: '未开通',
  [ABILITY_STATUS.yc]: '异常'
}
// 应用状态
export const applicationStatus: ValToLab = {
  [APPLICATION_STATUS.ty]: '停用',
  [APPLICATION_STATUS.qy]: '启用'
}
// 性别
export const sexObj: ValToLab = {
  [SEX.man]: '男',
  [SEX.woman]: '女'
}
// 后台-日志-登录日志-认证结果
export const certificationResult: ValToLab = {
  [+CERTIFICATION_RESULT.CG]: '成功',
  [+CERTIFICATION_RESULT.SB]: '失败'
}

// 抵扣勾选 统计确认状态
export const statisticsStatus: ValToLab = {
  [STATISTICS_STATUS.wtj]: '未统计',
  [STATISTICS_STATUS.ytj]: '已统计',
  [STATISTICS_STATUS.yqr]: '已确认'
}

// 增值税申报状态
export const taxDeclarationStatus: ValToLab = {
  [TAX_DECLARATION_STATUS.wsb]: '未申报',
  [TAX_DECLARATION_STATUS.ysb]: '已申报'
}

// 票据类型
export const noteType: ValToLab = {
  [NOTE_TYPE.fp]: '发票',
  [NOTE_TYPE.dkdjwspz]: '代扣代缴完税凭证',
  [NOTE_TYPE.hgjks]: '海关缴款书'
}

// 签收状态
export const collectionStatus: ValToLab = {
  [COLLECTION_STATUS.wcj]: '未签收',
  [COLLECTION_STATUS.ycj]: '已签收'
}

// 异常状态
export const normalStatus: ValToLab = {
  [NORMAL_STATUS.zc]: '正常',
  [NORMAL_STATUS.yc]: '异常',
  [NORMAL_STATUS.ysyc]: '疑似异常'
}

// 勾选类型
export const checkTypeObj: ValToLab = {
  [CHECK_TYPE.sqdk]: '申请抵扣',
  [CHECK_TYPE.cxdk]: '撤销抵扣',
  [CHECK_TYPE.sqbdk]: '申请不抵扣',
  [CHECK_TYPE.cxbdk]: '撤销不抵扣'
}

// 入账状态
export const intoAccountStatus: ValToLab = {
  [INTO_ACCOUNT_STATUS.wrz]: '未入账',
  [INTO_ACCOUNT_STATUS.sqkcjxz]: '税前扣除进行中',
  [INTO_ACCOUNT_STATUS.sqkcrz]: '税前扣除入账',
  [INTO_ACCOUNT_STATUS.bsqkcrz]: '不税前扣除入账',
  [INTO_ACCOUNT_STATUS.bsqkcjxz]: '不税前扣除进行中',
  [INTO_ACCOUNT_STATUS.sqkccxjxz]: '税前扣除撤销进行中',
  [INTO_ACCOUNT_STATUS.bsqkccxjxz]: '不税前扣除撤销进行中'
}
// 入账状态
export const rzztObj: ValToLab = {
  [RZZT.WRZ]: '未入账',
  [RZZT.YRZ]: '已入账',
  [RZZT.YRZCX]: '已入账撤销'
}
// 发票池-勾选状态
export const gxztObj: ValToLab = {
  [GXZT.WGX]: '未勾选',
  [GXZT.SQDK]: '申请抵扣',
  [GXZT.CXDK]: '撤销抵扣',
  [GXZT.SQBDK]: '申请不抵扣',
  [GXZT.CXBDK]: '撤销不抵扣'
}
// 发票池-不抵扣类型
export const bdklxObj: ValToLab = {
  [`${BDKLX.YYFYSXM}`]: '用于非应税项目',
  [`${BDKLX.YYMSXM}`]: '用于免税项目',
  [`${BDKLX.YYJTFLHZGRXF}`]: '用于集体福利或者个人消费',
  [`${BDKLX.ZSFZCSS}`]: '遭受非正常损失',
  [`${BDKLX.QT}`]: '其他'
}
// 发票池-处理结果
export const cljgObj: ValToLab = {
  [CLJG.CG]: '入账（撤销）成功',
  [CLJG.CWCP]: '查无此票',
  [CLJG.YC]: '该票异常无法入账',
  [CLJG.CFRZ]: '重复入账',
  [CLJG.QT]: '其他'
}
// 发票池-勾选处理结果
export const gxcljgObj: ValToLab = {
  [GXCLJG.GXCG]: ' 勾选（撤销）成功',
  [GXCLJG.CWCP]: ' 查无此票',
  [GXCLJG.YC]: ' 该票异常无法勾选',
  [GXCLJG.YQ]: ' 该票已经逾期无法认证',
  [GXCLJG.SD]: ' 当期已锁定（已申请统计）',
  [GXCLJG.CF]: ' 已勾选无法重复勾选',
  [GXCLJG.WDQ]: ' 未到期不可勾选（填发月份大于当前属期）',
  [GXCLJG.HMCF]: ' 该票号码重复',
  [GXCLJG.QT]: '其它'
}
// 发票池-勾选类型代码
export const gxlxdmObj: ValToLab = {
  [GXLXDM.SQDK]: '申请抵扣',
  [GXLXDM.CXDK]: '撤销抵扣',
  [GXLXDM.SQBDK]: '申请不抵扣',
  [GXLXDM.CXBDK]: '撤销不抵扣'
}
// 发票池-申请入账类型
export const sqrzlxObj: ValToLab = {
  [SQRZLX.WRZ]: '未入账',
  [SQRZLX.SQKC]: '入账（企业所得税税前扣除）',
  [SQRZLX.SQBKC]: '入账（企业所得税不扣除）',
  [SQRZLX.JYSDKC]: '入账（个人所得税经营所得税前扣除）',
  [SQRZLX.JYSDBKC]: '入账（个人所得税经营所得不扣除）',
  [SQRZLX.CX]: '入账撤销'
}
// 发票池-税种
export const szObj: ValToLab = {
  [SZ.XFS]: '消费税',
  [SZ.ZZS]: '增值税'
}
// 发票池-发票流转状态
export const fplzztObj: ValToLab = {
  [FPLZZT.FPWCJ]: '发票未签收',
  [FPLZZT.FPYCJ]: '发票已签收',
  [FPLZZT.FPYRZ]: '发票已入账',
  [FPLZZT.FPYGD]: '发票已归档'
}
// 发票池-发票状态
export const fpztObj: ValToLab = {
  [FPZT.ZC]: '正常',
  [FPZT.ZF]: '作废',
  [FPZT.YCH]: '已红冲',
  [FPZT.BFHZ]: '部分红冲',
  [FPZT.QBHC]: '全额冲红'
}
// 发票池-发票归集记录-归集结果
export const gjjgObj: ValToLab = {
  [GJJG.SB]: '失败',
  [GJJG.WKS]: '未开始-等待中',
  [GJJG.ZZGj]: '正在归集',
  [GJJG.GJCG]: '归集成功'
}
// 发票池-发票归集记录-归集类型
export const gjlxObj: ValToLab = {
  [GJLX.QL]: '全量归集',
  [GJLX.ZL]: '增量归集',
  [GJLX.CKZNX]: '出口转内销发票'
}
// 发票池-异常凭证状态
export const ycpzztObj: ValToLab = {
  [YCPZZT.ZC]: '正常',
  [YCPZZT.YCPZ]: '异常凭证',
  [YCPZZT.YSYCPZ]: '疑似异常凭证'
}
// 发票池-用途状态
export const ytztObj: ValToLab = {
  [YTZT.WSY]: '未使用',
  [YTZT.YSQDK]: '已申请抵扣',
  [YTZT.YSQTS]: '已申请退税',
  [YTZT.YSQDBTS]: '已申请代办退税',
  [YTZT.YG]: '已勾'
}
// 发票池-请单导入状态
export const qddrztObj: ValToLab = {
  [QDDRZT.CLZ]: '处理中',
  [QDDRZT.DRCG]: '导入成功',
  [QDDRZT.DRSB]: '导入失败'
}
// 发票-红字发票确认信息录入-是否含税
export const sfhsObj: ValToLab = {
  [SFHS.S]: '含税',
  [SFHS.F]: '不含税'
}
// 发票-红字发票确认信息录入-消费税用途
export const xfsytObj: ValToLab = {
  [XFS_YT.WGX]: '未勾选用途',
  [XFS_YT.YGX]: '已勾选用途'
}
// 发票-红字发票确认信息录入-发票用途
export const fpytObj: ValToLab = {
  [FPYT.WSY]: '未使用',
  [FPYT.YSSDK]: '已申请抵扣',
  [FPYT.YSSTS]: '已申请退税',
  [FPYT.YSQDBTS]: '已申请代办退税',
  [FPYT.YKXBDK]: '已勾选不抵扣（历史数据）',
  [FPYT.YSQDBTS_LSSJ]: '已申请代办退税（历史数据）',
  [FPYT.YSQBDK]: '已申请不抵扣',
  [FPYT.NXZCK]: '内销转出口',
  [FPYT.CKZNX]: '出口转内销',
  [FPYT.ZYTS]: '准予退税',
  [FPYT.BYTS]: '不予退税',
  [FPYT.DATS]: '冬奥退税'
}
// 勾选状态
export const checkStatus: ValToLab = {
  // [CHECK_STATUS.wgx]: '未勾选',
  // [CHECK_STATUS.dkgxjxz]: '抵扣勾选进行中',
  // [CHECK_STATUS.dkgx]: '抵扣勾选',
  ...fpytObj,
  [CHECK_STATUS.SQDKZ]: '申请抵扣中',
  [CHECK_STATUS.SQBDKZ]: '申请不抵扣中',
  [CHECK_STATUS.CXDKZ]: '撤销抵扣中',
  [CHECK_STATUS.CXBDKZ]: '撤销不抵扣中'
}
// 发票-蓝字发票-订单管理-合并拆分标志
export const hbcfbzObj: ValToLab = {
  [HBCFBZ.ZC]: '正常',
  [HBCFBZ.HB]: '合并',
  [HBCFBZ.CF]: '拆分'
}
// 发票-蓝字待开列表-发票票种
export const invoiceTypeObj: ValToLab = {
  [INVOICE_TYPE.ZP]: '数字化（电子专票）',
  [INVOICE_TYPE.PP]: '数字化（电子普票）'
}
// 发票-红字确认单-红字发票冲红原因代码
export const chyyDmObj: ValToLab = {
  [CHYYDM.KPYW]: '开票有误',
  [CHYYDM.XHTH]: '销货退回',
  [CHYYDM.FWZZ]: '服务中止',
  [CHYYDM.XSZR]: '销售折让'
}
// 发票-红字确认单-红字确认单状态
export const hzqrxxztDmObj: ValToLab = {
  [HZQRXXZTDM.WXQR]: '无需确认',
  [HZQRXXZTDM.DGFQR]: '销方录入待购方确认',
  [HZQRXXZTDM.DXFQR]: '购方录入待销方确认',
  [HZQRXXZTDM.YQR]: '购销双方已确认',
  [HZQRXXZTDM.GFZF]: '作废（销方录入购方否认）',
  [HZQRXXZTDM.XFZF]: '作废（购方录入销方否认）',
  [HZQRXXZTDM.ZF]: '作废（超72小时未确认）',
  [HZQRXXZTDM.CX]: '作废（发起方撤销）',
  [HZQRXXZTDM.QRHCX]: '作废（确认后撤销）',
  [HZQRXXZTDM.YCPZ]: '作废（异常凭证）'
}
// 发票-红字确认单-录入方身份
export const lrfsfObj: ValToLab = {
  [LRFSF.XF]: '销方',
  [LRFSF.GF]: '购方'
}
// 发票-红字确认单-确认即开票
export const qrjkpObj: ValToLab = {
  [QRJKP.F]: '否',
  [QRJKP.S]: '是'
}
// 发票类型
export const fplxObj: ValToLab = {
  // [FPLX.SYPP]: '所有普票',
  [FPLX.SYZP]: '所有专票',
  [FPLX.SYQT]: '所有其他',
  [FPLX.ZZS_ZYFP_01]: '增值税专用发票',
  [FPLX.HWYSY_ZZS_ZYFP_02]: '货物运输业增值税专用发票',
  [FPLX.JDCXSTYFP_03]: '机动车销售统一发票',
  [FPLX.ZZSPTFP_04]: '增值税普通发票',
  [FPLX.ZZS_DZ_ZYFP_08]: '增值税电子专用发票',
  [FPLX.ZZS_DZPTFP_10]: '增值税电子普通发票',
  [FPLX.JSFP_11]: '卷式发票',
  [FPLX.TXFFP_14]: '通行费发票',
  [FPLX.ESCXSTYFP_15]: '二手车销售统一发票',
  [FPLX.ZZSZYFP_81]: '电子发票（增值税专用发票）',
  [FPLX.DZFP_PTFP_82]: '电子发票（普通发票）',
  [FPLX.SDP_JDCXSTYFP_83]: '机动车销售电子统一发票',
  [FPLX.SDP_ESCXSTIFP_84]: '二手车销售电子统一发票',
  [FPLX.ZZFP_ZZSZYFP_85]: '纸质发票（增值税专用发票）',
  [FPLX.ZZFP_PTFP_86]: '纸质发票（普通发票）',
  [FPLX.FPLX_87]: '纸质发票（机动车销售统一发票）',
  [FPLX.FPLX_88]: '纸质发票（二手车销售统一发票）',
  [FPLX.ZDFP_TLDZKP_51]: '电子发票（铁路电子客票）',
  [FPLX.DZFP_HKYSKPDZXCD_61]: '电子发票（航空运输客票电子行程单）',
  [FPLX.QKLFP_99]: '区块链发票',
  [FPLX.COMMON_100]: '通用（电子）发票'
}
// 开票-开票记录详情-差额征税类型代码
export const cezslxdmObj: ValToLab = {
  [CEZSLXDM.QRKP]: '全额开票',
  [CEZSLXDM.CEKP]: '差额开票'
}
// 开票-开票记录详情-出口业务适用政策代码
export const ckywsyzcdmObj: ValToLab = {
  [CKYWSYZCDM.TSZC]: '退税政策',
  [CKYWSYZCDM.MSZC]: '免税政策',
  [CKYWSYZCDM.ZSZC]: '征税政策'
}
// 开票-开票记录详情-发票行性质
export const fphxzObj: ValToLab = {
  [FPHXZ.ZCH]: '正常行',
  [FPHXZ.ZKH]: '折扣行',
  [FPHXZ.BZKH]: '被折扣行'
}
// 开票-开票记录详情-优惠政策标识
export const yhzcbsObj: ValToLab = {
  [YHZCBS.JYZS]: '简易征收',
  [YHZCBS.XTCP]: '稀土产品',
  [YHZCBS.MS]: '免税',
  [YHZCBS.BZS]: '不征税',
  [YHZCBS.XZHT]: '先征后退',
  [YHZCBS.XZHT100]: '100%先征后退',
  [YHZCBS.XZHT50]: '50%先征后退',
  [YHZCBS.JYZS3]: '按3%简易征收',
  [YHZCBS.JYZS5]: '按5%简易征收',
  [YHZCBS.JZ]: '按5%简易征收减按1.5%计征',
  [YHZCBS.JZJT30]: '即征即退30%',
  [YHZCBS.JZJT5]: '即征即退50%',
  [YHZCBS.JZJT70]: '即征即退70%',
  [YHZCBS.JTJT100]: '即征即退100%',
  [YHZCBS.CSF3]: '超税负3%即征即退',
  [YHZCBS.CSF8]: '超税负8%即征即退',
  [YHZCBS.CSF12]: '超税负12%即征即退',
  [YHZCBS.CSF6]: '超税负6%即征即退'
}
// 开票-开票记录详情-优惠政策标识文本对应值
export const yhzcbsTextObj: ValToLab = {
  简易征收: YHZCBS.JYZS,
  稀土产品: YHZCBS.XTCP,
  免税: YHZCBS.MS,
  不征税: YHZCBS.BZS,
  先征后退: YHZCBS.XZHT,
  '100%先征后退': YHZCBS.XZHT100,
  '50%先征后退': YHZCBS.XZHT50,
  '按3%简易征收': YHZCBS.JYZS3,
  '按5%简易征收': YHZCBS.JYZS5,
  '按5%简易征收减按1.5%计征': YHZCBS.JZ,
  '即征即退30%': YHZCBS.JZJT30,
  '即征即退50%': YHZCBS.JZJT5,
  '即征即退70%': YHZCBS.JZJT70,
  '即征即退100%': YHZCBS.JTJT100,
  '超税负3%即征即退': YHZCBS.CSF3,
  '超税负8%即征即退': YHZCBS.CSF8,
  '超税负12%即征即退': YHZCBS.CSF12,
  '超税负6%即征即退': YHZCBS.CSF6
}
// 开票-开票记录详情-购买方自然人标志
export const gmfzrrbzObj: ValToLab = {
  [GMFZRRBZ.S]: '购买方是自然人',
  [GMFZRRBZ.F]: '购买方非自然人'
}
// 开票-开票记录详情-结算方式
export const jsfsObj: ValToLab = {
  [JSFS.XJ]: '现金',
  [JSFS.YHZZ]: '银行转账',
  [JSFS.PJ]: '票据',
  [JSFS.DSFZF]: '第三方支付',
  [JSFS.YFK]: '预付卡',
  [JSFS.QT]: '其他'
}
// 开票-开票记录详情-上传状态
export const scztObj: ValToLab = {
  [SCZT.SCCG]: '上传成功',
  [SCZT.CLZ]: '发票上传处理中',
  [SCZT.SCSB]: '上传失败',
  [SCZT.CFSC]: '重复上传'
}
// 开票-开票记录详情-上传状态(非乐企状态)
export const sczt2Obj: ValToLab = {
  [SCZT2.DSC]: '待上传',
  [SCZT2.DDSC]: '等待上传',
  [SCZT2.SCCG]: '上传成功',
  [SCZT2.SCSB]: '上传失败',
  [SCZT2.YSCCG]: '预上传成功'
}
// 开票-开票记录详情-收购发票类型代码
export const sgfplxdmObj: ValToLab = {
  [SGFPLXDM.RCP]: '农产品收购发票',
  [SGFPLXDM.GF]: '光伏收购发票',
  [SGFPLXDM.ESC]: '二手车收购发票'
}
// 开票-开票记录详情-特定要素
export const tdysObj: ValToLab = {
  [TDYS.FTDYS]: '非特定要素',
  [TDYS.CPY]: '成品油',
  [TDYS.XT]: '稀土',
  [TDYS.JZFW]: '建筑服务',
  [TDYS.HWYSFW]: '货物运输服务',
  [TDYS.BDCXS]: '不动产销售服务',
  [TDYS.BDCZL]: '不动产经营租赁服务',
  [TDYS.DSC]: '代收车船税',
  [TDYS.TXF]: '通行费',
  [TDYS.LKYSFW]: '旅客运输服务',
  [TDYS.ZY]: '医疗服务（住院）',
  [TDYS.MZ]: '医疗服务（门诊）',
  [TDYS.RCPXS]: '自产农产品销售',
  [TDYS.TLJ]: '拖拉机和联合收割机',
  [TDYS.JDC]: '机动车',
  [TDYS.ESC]: '二手车',
  [TDYS.RCPSG]: '农产品收购',
  [TDYS.GFSG]: '光伏收购',
  [TDYS.JY]: '卷烟',
  [TDYS.DZY]: '电子烟'
}
// 开票-开票记录详情-增值税即征即退代码
export const zzsjzjtdmObj: ValToLab = {
  [ZZSJZJTDM.RJCP]: '软件产品发票',
  [ZZSJZJTDM.ZYZHLYCP]: '资源综合利用产品发票',
  [ZZSJZJTDM.GDYSFW]: '管道运输服务发票',
  [ZZSJZJTDM.YXDCRZZL]: '有形动产融资租赁服务',
  [ZZSJZJTDM.YXDCRZXSHHZFW]: '有形动产融资性售后回租服务发票',
  [ZZSJZJTDM.XXQTCL]: '新型墙体材料发票',
  [ZZSJZJTDM.FLFDCP]: '风力发电产品发票',
  [ZZSJZJTDM.GFFDCP]: '光伏发电产品发票',
  [ZZSJZJTDM.DMRJCP]: '动漫软件产品发票',
  [ZZSJZJTDM.FJWHLW]: '飞机维修劳务发票',
  [ZZSJZJTDM.HJ]: '黄金发票',
  [ZZSJZJTDM.BJ]: '铂金发票'
}
// 开票记录详情-发票来源
export const fplyObj: ValToLab = {
  [FPLY.FPGJ]: '发票归集',
  [FPLY.FPYZ]: '发票验真'
}
// 开票记录详情-结算方式
export const jsfsDmObj: ValToLab = {
  [JSFSDM.XJ]: '现金',
  [JSFSDM.YHZZ]: '银行转账',
  [JSFSDM.PJ]: '票据',
  [JSFSDM.DSFZF]: '第三方支付',
  [JSFSDM.YFK]: '预付卡',
  [JSFSDM.QT]: '其他'
}
// 开票记录详情-平台勾选状态
export const ptgxztObj: ValToLab = {
  [PTGXZT.WGX]: '未勾选',
  [PTGXZT.JXZ]: '进行中',
  [PTGXZT.DKGX]: '抵扣勾选',
  [PTGXZT.BDKGX]: '不抵扣勾选'
}
// 开票记录详情-平台入账状态
export const ptrzztObj: ValToLab = {
  [PTRZZT.WRZ]: '未入账',
  [PTRZZT.JXZ]: '进行中',
  [PTRZZT.SQKCRZ]: '税前扣除入账',
  [PTRZZT.BSQKCRZ]: '不税前扣除入账'
}
// 开票记录详情-xml
export const xmlObj: ValToLab = {
  [XML.F]: '否',
  [XML.S]: '是',
  [XML.FPLX]: '发票类型',
  [XML.MYXML]: '没有xml'
}
// 开票记录详情-消费税用途标签
export const xfsytbqObj: ValToLab = {
  [XFSYTBQ.WGX]: '未勾选库存',
  [XFSYTBQ.YGX]: '已勾选库存'
}
// 开票记录详情-增值税用途标签
export const zzsytbqObj: ValToLab = {
  [ZZSYTBQ.WSY]: '未使用',
  [ZZSYTBQ.QBXMJJ]: '全部项目加计',
  [ZZSYTBQ.QBXMBJJ]: '全部项目不加计',
  [ZZSYTBQ.BFXMJJ]: '部分项目加计'
}
// 开票记录详情-交付状态
export const jfjlObj: ValToLab = {
  [JFJL.JFYC]: '交付异常',
  [JFJL.WJF]: '未交付',
  [JFJL.JFCG]: '交付成功',
  [JFJL.JFSB]: '交付失败'
}
// 开票-确认单详情-蓝字发票票种代码
export const lzfppzDmObj: ValToLab = {
  [LZFPPZDM.ZZS]: '增值税专用发票',
  [LZFPPZDM.PT]: '普通发票',
  [LZFPPZDM.JDC]: '机动车统一销售发票',
  [LZFPPZDM.ESC]: '二手车统一销售发票'
}
// 开票-确认单详情-是否纸质发票标志
export const sfzzfpbzObj: ValToLab = {
  [SFZZFPBZ.S]: '纸质发票',
  [SFZZFPBZ.F]: '电子发票'
}
// 开票-确认单详情-已开具红字发票标志
export const ykjjzfpbzObj: ValToLab = {
  [YKJJZFPBZ.S]: '已开具',
  [YKJJZFPBZ.F]: '未开具',
  [YKJJZFPBZ.KJZ]: '开具中',
  [YKJJZFPBZ.KJSB]: '开具失败'
}
// 开票-确认单详情-有效标志
export const yxbzObj: ValToLab = {
  [YXBZ.S]: '有效',
  [YXBZ.F]: '无效'
}
// 开票-订单管理-开具状态
export const ddkjztObj: ValToLab = {
  [DDKJZT.DTJ]: '未提交',
  [DDKJZT.BKP]: '不开票',
  [DDKJZT.LPKJZ]: '蓝票开具中',
  [DDKJZT.LPKJCG]: '蓝票开具成功',
  [DDKJZT.LPKJSB]: '蓝票开具失败',
  [DDKJZT.SQSB]: '申请失败(红字确认单)',
  [DDKJZT.GFQR]: '销方录入待购方确认',
  [DDKJZT.GFFR]: '作废(红字确认单)',
  [DDKJZT.XFCX]: '红票开具中',
  [DDKJZT.GFCX]: '红票开具成功',
  [DDKJZT.CS]: '红票开具失败',
  [DDKJZT.HPKJZ]: '红票开具中',
  [DDKJZT.HPKJCG]: '红票开具成功',
  [DDKJZT.HPKJSB]: '红票开具失败'
}
// 开票-开票记录-开具状态
export const kjztObj: ValToLab = {
  [KJZT.DKJ]: '待开具',
  [KJZT.KJZ]: '开具中',
  [KJZT.KJCG]: '开具成功',
  [KJZT.KJSB]: '开具失败',
  [KJZT.CGX]: '未提交'
}
// 开票-开票记录-打包状态
export const xzztObj: ValToLab = {
  [XZZT.XZZ]: '打包中',
  [XZZT.XZCC]: '打包成功',
  [XZZT.XZSB]: '打包失败'
}
// 用票-抵扣勾选-增值税申报状态
export const zzssbztObj: ValToLab = {
  [ZZSSBZT.WSB]: '未申报',
  [ZZSSBZT.YSB]: '已申报'
}
export const tjqrFplxObj: ValToLab = {
  [TJQR_FPLX.ZZSZYFP]: '增值税专用发票',
  [TJQR_FPLX.TXFFP]: '通行费发票',
  [TJQR_FPLX.QTPTFP]: '其他普通发票',
  [TJQR_FPLX.JDCTYXSFP]: '机动车统一销售发票',
  [TJQR_FPLX.HGJKS]: '海关缴款书',
  [TJQR_FPLX.DKDJWSPZ]: '代扣代缴完税凭证',
  [TJQR_FPLX.ZJ]: '总计',
  [TJQR_FPLX.HKYSKPDZXCD]: '航空运输客票电子行程单',
  [TJQR_FPLX.TLDZKP]: '铁路电子客票',
  [TJQR_FPLX.SGFP]: '收购发票',
  [TJQR_FPLX.ZCRCPPTFP]: '自产农产品普通发票'
}
export const tjfxTjlxObj: ValToLab = {
  [TJFX_TJLX.WGX]: '全部未抵扣勾选',
  [TJFX_TJLX.WGX3]: '3个月内未抵扣勾选',
  [TJFX_TJLX.WGX1]: '超过一年未抵扣勾选',
  [TJFX_TJLX.YCPZ]: '全部异常',
  [TJFX_TJLX.YCPZ3]: '3个月内异常',
  [TJFX_TJLX.YCPZ1]: '超过一年异常'
}
// 企业管理-是否申报
export const sfsbObj: ValToLab = {
  [SFSB.WSB]: '未申报',
  [SFSB.YSB]: '已申报'
}
// 企业管理-汇总确认状态
export const hzqrztObj: ValToLab = {
  [HZQRZT.SB]: '失败',
  [HZQRZT.WTJ]: '未提交',
  [HZQRZT.CG]: '成功',
  [HZQRZT.QRZ]: '确认中',
  [HZQRZT.YCX]: '已撤销'
}
// 企业管理-推送范围
export const tsfwObj: ValToLab = {
  [TSFW.YCPZ]: '异常凭证',
  [TSFW.YSYCPZ]: '疑似异常凭证'
}
// 企业管理-额度操作类型
export const edczrlObj: ValToLab = {
  [EDCZRL.XZED]: '下载额度',
  [EDCZRL.THED]: '退回额度',
  [EDCZRL.BGSSQ]: '变更所属期'
}
// 企业管理-额度操作变更结果
export const edbgjgObj: ValToLab = {
  [EDBGJG.CG]: '成功',
  [EDBGJG.SB]: '失败'
}
// 发票种类
export const fpzlObj: ValToLab = {
  [FPZL.LZFP]: '蓝字发票',
  [FPZL.HZFP]: '红字发票',
  [FPZL.HJ]: '合计'
}
// 仪表盘-时间选择
export const sjlxObj: ValToLab = {
  [SJLX.Y]: '按月度',
  [SJLX.JD]: '按季度',
  [SJLX.ND]: '按年度'
}
// 用票勾选规则开启状态
export const gzkqztObj: ValToLab = {
  [GZKQZT.WSZ]: '未设置',
  [GZKQZT.YKQ]: '已开启',
  [GZKQZT.YGB]: '已关闭'
}

// 用票勾选规则配置类型
export const gzpzlxObj: ValToLab = {
  [GZPZLX.DKGX]: '抵扣勾选',
  [GZPZLX.RZGX]: '入账勾选'
}

// 用票勾选规则配置类型
export const gzywztObj: ValToLab = {
  [GZYWZT.YGJ]: '已归集',
  [GZYWZT.YQS]: '已签收'
}

// 纳税人类型
export const nsrlxObj: ValToLab = {
  [NSRLX.YBNSR]: '一般纳税人',
  [NSRLX.XGMNSR]: '小规模纳税人',
  [NSRLX.ZDJXGMNSR]: '转登记小规模纳税人',
  [NSRLX.FDQYBNSR]: '辅导期一般纳税人',
  [NSRLX.ZRR]: '自然人'
}

// 风险纳税人类型
export const fxnsrlxObj: ValToLab = {
  [FXNSRLX.FFXNSR]: '非风险纳税人',
  [FXNSRLX.ILNSR]: 'I类（高风险）纳税人',
  [FXNSRLX.IILNSR]: 'II类（中风险）纳税人',
  [FXNSRLX.IIILNSR]: 'II类（低风险）纳税人',
  [FXNSRLX.IVLNSR]: 'IV类（无风险）纳税人'
}

// 纳税人预警级别
export const nsryjjbObj: ValToLab = {
  [NSRYJJB.WYJ]: '无预警',
  [NSRYJJB.RYJ]: '红色预警',
  [NSRYJJB.YYJ]: '黄色预警',
  [NSRYJJB.BYJ]: '蓝色预警'
}

// 风险纳税人标志
export const fxnsrbzObj: ValToLab = {
  [FXNSRBZ.ZC]: '正常纳税人',
  [FXNSRBZ.FX]: '风险纳税人'
}
// 邮箱启用状态
export const yxqyztObj: ValToLab = {
  [YXQYZT.QY]: '启用',
  [YXQYZT.TY]: '停用',
  [YXQYZT.Y]: '启用',
  [YXQYZT.N]: '停用'
}
// 参数配置-限额预警配置-限制预计范围
export const xzyjfwObj: ValToLab = {
  [XZYJFW.DYLJKPECC]: '单月累计开票额超出',
  [XZYJFW.JDLJKPECC]: '季度累计开票额超出',
  [XZYJFW.LXSRGYLJKPECC]: '连续12月累计开票额超出'
}
// 参数配置-限额预警配置-限制预警类型
export const xzyjlxObj: ValToLab = {
  [XZYJLX.CETX]: '超额提醒',
  [XZYJLX.CEJZKP]: '超额禁止开票',
  [XZYJLX.BSZ]: '不设置'
}
// 开票信息管理-附加信息管理-数据类型
export const fjSjlxObj: ValToLab = {
  [FJSJLX.RQX]: '日期型',
  [FJSJLX.SZX]: '数据型',
  [FJSJLX.WBX]: '文本型'
}
// 发票票种
export const fppzObj: ValToLab = {
  [FPPZ.PT]: '电子发票（普通发票）',
  [FPPZ.ZY]: '电子发票（专用发票）',
  [INVOICE_TYPE.JDCXS]: '机动车销售电子统一发票',
  [FPLX.ZZSZYFP_81]: '电子发票（专用发票）',
  [FPLX.DZFP_PTFP_82]: '电子发票（普通发票）',
  [FPLX.SDP_JDCXSTYFP_83]: '机动车销售电子统一发票',
  [FPLX.ZDFP_TLDZKP_51]: '电子发票（铁路电子客票）',
  [FPLX.DZFP_HKYSKPDZXCD_61]: '电子发票（航空运输客票电子行程单）'
}
export const tjfsObj: ValToLab = {
  [TJFS.SD]: '手动录入',
  [TJFS.PLDR]: '批量导入',
  [TJFS.SMLR]: '扫码录入'
}
// 企业绑定管理-接入单位-是否沙箱
export const sfsxObj: ValToLab = {
  [SFSX.S]: '是',
  [SFSX.F]: '否'
}
// 查验结果
export const cyjgObj: ValToLab = {
  [CYJG.CYSB]: '查验失败',
  [CYJG.BKCYPZ]: '不可查验票种',
  [CYJG.CYCG]: '查验成功'
}
// 证件类型
export const zjlxObj: ValToLab = {
  [ZJLX.DW]: '单位',
  [ZJLX.ZZJGDMZ]: '组织机构代码证',
  [ZJLX.YYZZ]: '营业执照',
  [ZJLX.SSDJZ]: '税务登记证',
  [ZJLX.QTDWZJ]: '其他单位证件',
  [ZJLX.GR]: '个人',
  [ZJLX.JMSFZ]: '居民身份证',
  [ZJLX.JGZ]: '军官证',
  [ZJLX.WJJGZ]: '武警警官证',
  [ZJLX.SBZ]: '士兵证',
  [ZJLX.JDLTXGBZ]: '军队离退休干部证',
  [ZJLX.CJRZ]: '残疾人证',
  [ZJLX.CJJRZ]: '残疾军人证（1-8级）',
  [ZJLX.WGHZ]: '外国护照',
  [ZJLX.GATB]: '港澳同胞回乡证',
  [ZJLX.GATXZ]: '港澳居民来往内地通行证',
  [ZJLX.TBZ]: '台胞证',
  [ZJLX.ZGGATXZ]: '中华人民共和国往来港澳通行证',
  [ZJLX.TWDLTXZ]: '台湾居民来往大陆通行证',
  [ZJLX.DLTWTXZ]: '大陆居民往来台湾通行证',
  [ZJLX.WGRJZZ]: '外国人居留证',
  [ZJLX.WJGZ]: '外交官证',
  [ZJLX.SGZ]: '使（领事）馆证',
  [ZJLX.HYZ]: '海员证',
  [ZJLX.XGYJSFZ]: '香港永久性居民身份证',
  [ZJLX.TWSFZ]: '台湾身份证',
  [ZJLX.AMSFZ]: '澳门特别行政区永久性居民身份证',
  [ZJLX.WGRSFZ]: '外国人身份证件',
  [ZJLX.GXCYZ]: '高校毕业生自主创业证',
  [ZJLX.SYDJZ]: '就业失业登记证',
  [ZJLX.TWZ]: '退休证',
  [ZJLX.LWZ]: '离休证',
  [ZJLX.ZGFZ]: '中国护照',
  [ZJLX.SBZMZYZ]: '城镇退役士兵自谋职业证',
  [ZJLX.SZJSSFZ]: '随军家属身份证明',
  [ZJLX.ZYZS]: '中国人民解放军军官转业证书',
  [ZJLX.TCXYZ]: '中国人民解放军义务兵退出现役证',
  [ZJLX.SGTVXYZ]: '中国人民解放军士官退出现役证',
  [ZJLX.WGTYJJLSFZ]: '外国人永久居留身份证（外国人永久居留证）',
  [ZJLX.JYCYZ]: '就业创业证',
  [ZJLX.XGHZ]: '香港特别行政区护照',
  [ZJLX.AMHZ]: '澳门特别行政区护照',
  [ZJLX.ZGGAJZZ]: '中华人民共和国港澳居民居住证',
  [ZJLX.ZGTWJZZ]: '中华人民共和国台湾居民居住证',
  [ZJLX.GZXKZA]: '《中华人民共和国外国人工作许可证》（A类）',
  [ZJLX.GZXKZB]: '《中华人民共和国外国人工作许可证》（B类）',
  [ZJLX.GZXKZC]: '《中华人民共和国外国人工作许可证》（C类）',
  [ZJLX.CSZM]: '出生医学证明',
  [ZJLX.QTZJ]: '其他个人证件'
}
export const jtgjlxObj: ValToLab = {
  [JTGJLX.FJ]: '飞机',
  [JTGJLX.HC]: '火车',
  [JTGJLX.CTQC]: '长途汽车',
  [JTGJLX.GGJT]: '公共交通',
  [JTGJLX.CZC]: '出租车',
  [JTGJLX.QC]: '汽车',
  [JTGJLX.CB]: '船舶',
  [JTGJLX.QT]: '其他'
}
// 医疗机构类型
export const yljglxdmObj: ValToLab = {
  [YLJGLXDM.A]: '医院',
  [YLJGLXDM.A1]: '综合医院',
  [YLJGLXDM.A100]: '综合医院',
  [YLJGLXDM.A2]: '中医医院',
  [YLJGLXDM.A210]: '中医（综合）医院',
  [YLJGLXDM.A220]: '中医专科医院',
  [YLJGLXDM.A221]: '肛肠医院',
  [YLJGLXDM.A222]: '骨伤医院',
  [YLJGLXDM.A223]: '针炙医院',
  [YLJGLXDM.A224]: '按摩医院',
  [YLJGLXDM.A229]: '其他中医专科医院',
  [YLJGLXDM.A3]: '中西医结合医院',
  [YLJGLXDM.A300]: '中西医结合医院',
  [YLJGLXDM.A4]: '民族医院',
  [YLJGLXDM.A411]: '蒙医院',
  [YLJGLXDM.A412]: '藏医院',
  [YLJGLXDM.A413]: '维医院',
  [YLJGLXDM.A414]: '傣医院',
  [YLJGLXDM.A419]: '其他民族医院',
  [YLJGLXDM.A5]: '专科医院',
  [YLJGLXDM.A511]: '口腔医院',
  [YLJGLXDM.A512]: '眼科医院',
  [YLJGLXDM.A513]: '鼻喉科医院',
  [YLJGLXDM.A514]: '肿瘤医院',
  [YLJGLXDM.A515]: '心血管病医院',
  [YLJGLXDM.A516]: '胸科医院',
  [YLJGLXDM.A517]: '血液病医院',
  [YLJGLXDM.A518]: '妇产（科）医院',
  [YLJGLXDM.A519]: '儿童医院',
  [YLJGLXDM.A520]: '精神病医院',
  [YLJGLXDM.A521]: '传染病医院',
  [YLJGLXDM.A522]: '皮肤病医院',
  [YLJGLXDM.A523]: '结核病及院',
  [YLJGLXDM.A524]: '麻风病医院',
  [YLJGLXDM.A525]: '职业病医院',
  [YLJGLXDM.A526]: '骨科医院',
  [YLJGLXDM.A527]: '康复医院',
  [YLJGLXDM.A528]: '整形外科医院',
  [YLJGLXDM.A529]: '美容医院',
  [YLJGLXDM.A539]: '其他专科医院',
  [YLJGLXDM.A6]: '疗养院',
  [YLJGLXDM.A600]: '疗养院',
  [YLJGLXDM.A7]: '护理院（站）',
  [YLJGLXDM.A710]: '护理院',
  [YLJGLXDM.A720]: '护理站',
  [YLJGLXDM.B]: '社区卫生服务中心（站）',
  [YLJGLXDM.B1]: '社区卫生服务中心',
  [YLJGLXDM.B100]: '社区卫生服务中心',
  [YLJGLXDM.B2]: '社区卫生服务站',
  [YLJGLXDM.B200]: '社区卫生服务站',
  [YLJGLXDM.C]: '卫生院',
  [YLJGLXDM.C2]: '乡镇卫生院',
  [YLJGLXDM.C210]: '中心卫生院',
  [YLJGLXDM.C220]: '乡卫生院',
  [YLJGLXDM.D]: '门诊部、诊所、医务室、村卫生室',
  [YLJGLXDM.D1]: '门诊部',
  [YLJGLXDM.D110]: '综合门诊部',
  [YLJGLXDM.D120]: '中医门诊部',
  [YLJGLXDM.D121]: '中医（席合）门诊部',
  [YLJGLXDM.D122]: '中医专科门诊部',
  [YLJGLXDM.D130]: '中西医结合门诊部',
  [YLJGLXDM.D140]: '民族医门诊部',
  [YLJGLXDM.D150]: '专科门诊部',
  [YLJGLXDM.D151]: '并通专科门诊部',
  [YLJGLXDM.D152]: '口腔门诊部',
  [YLJGLXDM.D153]: '眼科门诊部',
  [YLJGLXDM.D154]: '医疗美容门诊部',
  [YLJGLXDM.D155]: '精神卫生门诊部',
  [YLJGLXDM.D159]: '其他专科门诊部',
  [YLJGLXDM.D2]: '诊所',
  [YLJGLXDM.D211]: '普通诊所',
  [YLJGLXDM.D212]: '中医诊所',
  [YLJGLXDM.D213]: '中西医结合诊所',
  [YLJGLXDM.D214]: '民族医诊所',
  [YLJGLXDM.D215]: '口腔诊所',
  [YLJGLXDM.D216]: '医疗美容诊所',
  [YLJGLXDM.D217]: '精神卫生诊所',
  [YLJGLXDM.D229]: '其他诊所',
  [YLJGLXDM.D3]: '卫生所（室）',
  [YLJGLXDM.D300]: '卫生所（室）',
  [YLJGLXDM.D4]: '医务室',
  [YLJGLXDM.D400]: '医务室',
  [YLJGLXDM.D5]: '中小学卫生保健所',
  [YLJGLXDM.D500]: '中小学卫生保健所',
  [YLJGLXDM.D6]: '村卫生室',
  [YLJGLXDM.D600]: '村卫生室',
  [YLJGLXDM.E]: '急救中心（站）',
  [YLJGLXDM.E1]: '急救中心',
  [YLJGLXDM.E100]: '急救中心',
  [YLJGLXDM.E2]: '急救中心站',
  [YLJGLXDM.E200]: '急救中心站',
  [YLJGLXDM.E3]: '急救站',
  [YLJGLXDM.E300]: '急救站',
  [YLJGLXDM.F]: '采供血机构',
  [YLJGLXDM.F1]: '血站',
  [YLJGLXDM.F110]: '血液中心',
  [YLJGLXDM.F120]: '中心血站',
  [YLJGLXDM.F130]: '基层血站、中心血库',
  [YLJGLXDM.F2]: '单采血浆站',
  [YLJGLXDM.F200]: '单采血浆站',
  [YLJGLXDM.G]: '妇幼保健院（所、站）',
  [YLJGLXDM.G1]: '妇幼保健院',
  [YLJGLXDM.G100]: '妇幼保健院',
  [YLJGLXDM.G2]: '妇幼保健所',
  [YLJGLXDM.G200]: '妇幼保健所',
  [YLJGLXDM.G3]: '妇幼保健站',
  [YLJGLXDM.G300]: '妇幼保健站',
  [YLJGLXDM.G4]: '生殖保健中心',
  [YLJGLXDM.G400]: '生殖保健中心',
  [YLJGLXDM.H]: '专科疾病防治院（所、站）',
  [YLJGLXDM.H1]: '专科疾病防治院',
  [YLJGLXDM.H111]: '传染病防治院',
  [YLJGLXDM.H112]: '结核病防治院',
  [YLJGLXDM.H113]: '职业病防治院',
  [YLJGLXDM.H119]: '其他专科疾病防治院',
  [YLJGLXDM.H2]: '专科疾病防治所（站、中心）',
  [YLJGLXDM.H211]: '口腔病防治所（站、中心）',
  [YLJGLXDM.H212]: '精神病防治所（站、中心）',
  [YLJGLXDM.H213]: '皮肤病防治所（站、中心）',
  [YLJGLXDM.H214]: '结核病防治所（站、中心）',
  [YLJGLXDM.H215]: '麻凤病防治所（站、中心）',
  [YLJGLXDM.H216]: '职业病防治所（站、中心）',
  [YLJGLXDM.H217]: '寄生虫病防治所（站、中心）',
  [YLJGLXDM.H218]: '地方病防治所（站，中心）',
  [YLJGLXDM.H219]: '血吸虫病防治所（站、中心）',
  [YLJGLXDM.H220]: '药物戒毒所（中心）',
  [YLJGLXDM.H229]: '其他专科疾病防治所（站、中心）',
  [YLJGLXDM.J]: '疾病预防控制中心（防疫站）',
  [YLJGLXDM.J1]: '疾病预防控制中心',
  [YLJGLXDM.J100]: '疾病预防控制中心',
  [YLJGLXDM.J2]: '卫生防疫站',
  [YLJGLXDM.J200]: '卫生防疫站',
  [YLJGLXDM.J3]: '卫生防病中心',
  [YLJGLXDM.J300]: '卫生防病中心',
  [YLJGLXDM.J4]: '预防保健中心',
  [YLJGLXDM.J400]: '预防保健中心',
  [YLJGLXDM.K]: '卫生监督所（局）',
  [YLJGLXDM.K1]: '卫生监督所（局）',
  [YLJGLXDM.K100]: '卫生监督所（局）',
  [YLJGLXDM.L]: '卫生监督检验（监测、检测）所（站）',
  [YLJGLXDM.L1]: '卫生（综合）监督检验（监测，检测）所（站）',
  [YLJGLXDM.L100]: '卫生（综合）监督检验（监测，检测）所（站）',
  [YLJGLXDM.L2]: '环境卫生监悴检验（监测、检测）所（站）',
  [YLJGLXDM.L200]: '坏境卫生监督检验（监测、检测）所（站）',
  [YLJGLXDM.L3]: '放射卫生监督检验（监测、检测）所（站）',
  [YLJGLXDM.L300]: '放射卫生监督检验（监测、检测）所（站）',
  [YLJGLXDM.L4]: '劳动（职业、工业）卫生监督检验（监测、检测）所（站）',
  [YLJGLXDM.L400]: '劳动（职业、工业）卫生监督检验（监测、检测）所（站）',
  [YLJGLXDM.L5]: '食品卫生监督检验（监测、检测）所（站）',
  [YLJGLXDM.L500]: '食品卫生监督检验（监测、检测）所（站）',
  [YLJGLXDM.L6]: '学校卫生监督检验（监测、检测）所（站）',
  [YLJGLXDM.L600]: '学校卫生监督检验（监测、检测）所（站）',
  [YLJGLXDM.L9]: '其他卫生监督检验（监测，检测）所（站）',
  [YLJGLXDM.L900]: '其他卫生监督检验（监测，检测）所（站）',
  [YLJGLXDM.M]: '医学科学研究机构',
  [YLJGLXDM.M1]: '医学科学（研究）院（所）',
  [YLJGLXDM.M100]: '医学科学（研究）院（所）',
  [YLJGLXDM.M2]: '预防医学研究院（所）',
  [YLJGLXDM.M200]: '预防医学研究院（所）',
  [YLJGLXDM.M3]: '中医（药）研究院（所）',
  [YLJGLXDM.M300]: '中医（药）研究院（所）',
  [YLJGLXDM.M4]: '中西医结合研究所',
  [YLJGLXDM.M400]: '中西医结合研究所',
  [YLJGLXDM.M5]: '民族医（药）学研究所',
  [YLJGLXDM.M500]: '民族医（药）学研究所',
  [YLJGLXDM.M6]: '医学专科研究所',
  [YLJGLXDM.M611]: '基础医学研究所',
  [YLJGLXDM.M612]: '病毒学研究所',
  [YLJGLXDM.M613]: '老年医学研究所',
  [YLJGLXDM.M614]: '肿瘤（防治）研究所',
  [YLJGLXDM.M615]: '心血管病研究所',
  [YLJGLXDM.M616]: '血液学研究所',
  [YLJGLXDM.M617]: '整形外科研究所',
  [YLJGLXDM.M618]: '特种卫生研究所',
  [YLJGLXDM.M619]: '放射医学研究所',
  [YLJGLXDM.M620]: '医学生物学研究所',
  [YLJGLXDM.M621]: '生物医学工程研究所',
  [YLJGLXDM.M622]: '实验动物研究所',
  [YLJGLXDM.M623]: '结核病防治研究所',
  [YLJGLXDM.M624]: '皮肤病与性病防治研究所',
  [YLJGLXDM.M625]: '寄生虫病防治研允所',
  [YLJGLXDM.M626]: '地方病防治研究所',
  [YLJGLXDM.M627]: '血吸虫病防治研究所',
  [YLJGLXDM.M628]: '流行病学研究所',
  [YLJGLXDM.M629]: '医学微生物学研究所',
  [YLJGLXDM.M630]: '环境卫生研究所',
  [YLJGLXDM.M631]: '劳动卫生（职业病）研究所',
  [YLJGLXDM.M632]: '营养与食品卫生研究所',
  [YLJGLXDM.M633]: '儿少卫生研究所',
  [YLJGLXDM.M634]: '医学信息研究所',
  [YLJGLXDM.M649]: '其他医学专科研究所',
  [YLJGLXDM.M7]: '药学研究所',
  [YLJGLXDM.M700]: '药学研究所',
  [YLJGLXDM.N]: '医学教育机构',
  [YLJGLXDM.N1]: '医学普通高中等学校',
  [YLJGLXDM.N110]: '医学普通高等学校',
  [YLJGLXDM.N111]: '医学院',
  [YLJGLXDM.N112]: '中医（药）学院',
  [YLJGLXDM.N113]: '民族医（药）学院',
  [YLJGLXDM.N119]: '其他医学普通高等学校',
  [YLJGLXDM.N120]: '医学普通中等专业学校',
  [YLJGLXDM.N121]: '卫生学校',
  [YLJGLXDM.N122]: '中医（药）学校',
  [YLJGLXDM.N123]: '民族医（药）学校',
  [YLJGLXDM.N124]: '护士学校',
  [YLJGLXDM.N129]: '其他医学普通中等专业学校',
  [YLJGLXDM.N2]: '医学成人学校',
  [YLJGLXDM.N210]: '医学成人高等学校',
  [YLJGLXDM.N211]: '职工医学院',
  [YLJGLXDM.N212]: '卫生管理干部学院',
  [YLJGLXDM.N219]: '其他医学成人高等学校',
  [YLJGLXDM.N220]: '医学成人中等学校',
  [YLJGLXDM.N221]: '卫生职业（工）中等专业学校',
  [YLJGLXDM.N222]: '中医（药）职业中等专业学校',
  [YLJGLXDM.N223]: '卫生进修学校',
  [YLJGLXDM.N229]: '其他医学成人中等学校',
  [YLJGLXDM.N3]: '医学在职培训机构',
  [YLJGLXDM.N300]: '医学在职培训机构',
  [YLJGLXDM.O]: '健康教育所（站、中心）',
  [YLJGLXDM.O1]: '健康教育所',
  [YLJGLXDM.O100]: '健康教育所',
  [YLJGLXDM.O2]: '健康教育站（中心）',
  [YLJGLXDM.O200]: '健康教育站（中心）',
  [YLJGLXDM.P]: '其他卫生机构',
  [YLJGLXDM.P1]: '临床检验中心（所、站）',
  [YLJGLXDM.P110]: '临床检验中心',
  [YLJGLXDM.P120]: '临床检验所（站）',
  [YLJGLXDM.P2]: '卫生新闻出版杜',
  [YLJGLXDM.P210]: '卫生图书出版社',
  [YLJGLXDM.P220]: '卫生报纸出版社',
  [YLJGLXDM.P230]: '卫生杂志社',
  [YLJGLXDM.P290]: '其他卫生新闻出版社',
  [YLJGLXDM.P9]: '其他卫生事业机构',
  [YLJGLXDM.P911]: '神病收容所'
}
// 医保类型代码
export const yblxdmObj: ValToLab = {
  [YBLXDM.ZGJBYLBX]: '职工基本医疗保险',
  [YBLXDM.CXJMJBYLBX]: '城乡居民基本医疗保险',
  [YBLXDM.LX]: '离休',
  [YBLXDM.QTYLBX]: '其他医疗保险',
  [YBLXDM.ZF]: '自费'
}
// 智能勾选方式
export const zngxfsObj: ValToLab = {
  [ZNGXFS.SFLDS]: '按增值税税负率倒算',
  [ZNGXFS.YJZZSDS]: '按应缴增值税倒算',
  [ZNGXFS.DKJXSE]: '按录入抵扣进项税额'
}
// 退税勾选
export const tsgxztObj: ValToLab = {
  [TSGXZT.WGX]: '未勾选',
  [TSGXZT.TSGXZ]: '退税勾选中',
  [TSGXZT.YTSGX]: '已退税勾选'
}
// 增值税申报进项抵扣汇总
export const zzssbjxdkhzObj: ValToLab = {
  [ZZSSBJXDKHZ.ZZSZYFP]: '本期认证相符的增值税专用发票（第2行）',
  [ZZSSBJXDKHZ.HGJKS]: '海关进口增值税缴款书（第5行）',
  [ZZSSBJXDKHZ.NCPHZXSFP]: '农产品收购发票或者销售发票（第6行）',
  [ZZSSBJXDKHZ.DKDJSSJKPZ]: '代扣代缴税收缴款凭证（第7行）',
  [ZZSSBJXDKHZ.JJKCNCP]: '加计扣除农产品进项税额（第8a行）',
  [ZZSSBJXDKHZ.WMQYJX]: '外贸企业进项税额抵扣证明（第11行）',
  [ZZSSBJXDKHZ.YCPZ]: '本期认证相符的解除异常凭证（23a）'
}

// 农产品加计扣除勾选统计结果
export const rcpjjkcgxtjjgObj: ValToLab = {
  [RCPJJKCGXTJJG.ZZSZYFP]: '增值税专用发票',
  [RCPJJKCGXTJJG.SGFP]: '收购发票',
  [RCPJJKCGXTJJG.MSZCNCP]: '免税自产农产品普通发票',
  [RCPJJKCGXTJJG.HGJKS]: '海关缴款书',
  [RCPJJKCGXTJJG.YXDK]: '录入本期有效抵扣税额'
}
// 智能勾选-处理状态
export const clztObj: ValToLab = {
  [CLZT.DCL]: '待处理',
  [CLZT.CXCG]: '查询成功',
  [CLZT.CXZ]: '查询中',
  [CLZT.CXSB]: '查询失败'
}
// 处理结果
export const czztObj: ValToLab = {
  [CZZT.DRSB]: '导入失败',
  [CZZT.CLZ]: '处理中',
  [CZZT.DRCG]: '导入成功'
}
// 支付渠道
export const zfqdObj: ValToLab = {
  [ZFQD.XJ]: '现金',
  [ZFQD.YHZZ]: '银行转账',
  [ZFQD.PJ]: '票据',
  [ZFQD.JJK]: '借记卡',
  [ZFQD.XYK]: '信用卡',
  [ZFQD.GWK]: '购物卡/券',
  [ZFQD.YHJ]: '优惠券',
  [ZFQD.SCJF]: '商场积分',
  [ZFQD.ZFB]: '支付宝',
  [ZFQD.WXZF]: '微信支付',
  [ZFQD.YSF]: '云闪付',
  [ZFQD.APPLE_PAY]: 'Apple Pay',
  [ZFQD.SAMSUNG_PAY]: 'Samsung Pay',
  [ZFQD.QT]: '其它'
}
// 煤炭种类
export const mtzlObj: ValToLab = {
  [MTZL.ZFBGM]: '政府保供煤',
  [MTZL.CXY_0]: '长协煤-协议期不足半年',
  [MTZL.CXY_1]: '长协煤-协议期在半年至一年之间',
  [MTZL.CXY_2]: '长协煤-协议期在一年至两年之间',
  [MTZL.CXY_3]: '长协煤-协议期在两年以上',
  [MTZL.SCM]: '市场煤'
}
